import { render, staticRenderFns } from "./SuccessMessagePublic.vue?vue&type=template&id=82baf41a&scoped=true"
import script from "./SuccessMessagePublic.vue?vue&type=script&lang=js"
export * from "./SuccessMessagePublic.vue?vue&type=script&lang=js"
import style0 from "./SuccessMessagePublic.vue?vue&type=style&index=0&id=82baf41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82baf41a",
  null
  
)

export default component.exports